import React, { ElementType } from 'react';
import './ListItem.scss';

const ListItem = ({
  Icon,
  image,
  href,
  alt,
  title,
  description,
}: {
  Icon?: ElementType;
  image?: string;
  href?: string;
  alt?: string;
  title: string;
  description: string;
}) => {
  return (
    <div className="list-item">
      {Icon && <Icon size={48} />}
      {image && (
        <a href={href} target="_blank" rel="noopener noreferrer">
          <img src={image} alt={alt} />
        </a>
      )}
      <div className="list-item-title">{title}</div>
      <div className="list-item-description">{description}</div>
    </div>
  );
};

export default ListItem;
